"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleDrop = void 0;
var uuid_1 = require("uuid");
var handleDrop = function (props) { return function (e) {
    // Prevent browser from opening the file
    e.preventDefault();
    var items = props.value ? __spreadArray([], props.value, true) : [];
    if (e.target && e.target.files) {
        var c = e.target.files.length;
        for (var i = 0; i < c; i++) {
            var f = e.target.files[i];
            items.push({
                uuid: (0, uuid_1.v4)(),
                file: f,
                size: f.size,
                name: f.name
            });
        }
    }
    else if (e.dataTransfer) {
        var c = e.dataTransfer.files.length;
        for (var i = 0; i < c; i++) {
            var f = e.dataTransfer.files[i];
            items.push({
                uuid: (0, uuid_1.v4)(),
                file: f,
                size: f.size,
                name: f.name
            });
        }
    }
    props.setHover && props.setHover(false);
    props.onChange(props.multipleFiles ? items : items.length > 0 ? [items[0]] : items);
}; };
exports.handleDrop = handleDrop;
//# sourceMappingURL=handleDrop.js.map